import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/en_flag.png'
import _imports_1 from '@/assets/de_flag.png'


const _hoisted_1 = { id: "nav-content-wrapper" }
const _hoisted_2 = { style: {"margin-left":"auto","display":"flex","flex-direction":"row","align-items":"center"} }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<form style=\"display:flex;flex-direction:row;\"><label for=\"lang-en\"><input type=\"radio\" id=\"lang-en\" name=\"language\" checked><img src=\"" + _imports_0 + "\"></label><label for=\"lang-de\"><input type=\"radio\" id=\"lang-de\" name=\"language\"><img src=\"" + _imports_1 + "\"></label></form>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        id: "nav-logo"
      }),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/search" }, {
          default: _withCtx(() => [
            _createTextVNode("Search")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            _createTextVNode("About")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/faq" }, {
          default: _withCtx(() => [
            _createTextVNode("FAQ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/contact" }, {
          default: _withCtx(() => [
            _createTextVNode("Contact")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_link, { to: "/login" }, {
          default: _withCtx(() => [
            _createTextVNode("Login")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}